import { Box, Stack, Typography } from "@compass/core";
import {
  captionStyles,
  copyrightContainerStyles,
  illustrationContainerStyles,
  illustrationImageStyles,
  sidePanelStyles,
} from "../styles/authStyles";
import { BrandingHeader } from "./BrandingHeader";

export const ForgotCredentialSidePanel = () => (
  <Stack sx={sidePanelStyles}>
    <Box sx={{ pt: 6 }}>
      <BrandingHeader />
    </Box>
    <Box sx={illustrationContainerStyles}>
      <Box
        component="img"
        src="/images/ForgotPassword.png"
        alt="Forgot password illustration"
        sx={illustrationImageStyles}
      />
    </Box>
    <Box sx={copyrightContainerStyles}>
      <Typography variant="caption" sx={captionStyles}>
        Copyright © 2006-{new Date().getFullYear()} Cobro Consulting. All
        Rights Reserved.
      </Typography>
    </Box>
  </Stack>
);